module.exports = __webpack_public_path__ + "img/Zugführer_Einsatzeinheit.1db2c0dc.svg";